import { Context } from '@leverege/plugin';
import MoltenUtil from "../MoltenUtil.js";
function create(pluginName) {
  return opts => {
    const {
      settings
    } = opts;
    const {
      props
    } = opts;
    let viewModel = settings;
    const context = opts || {};
    const cfgs = MoltenUtil.sortedPlugins(pluginName, Context.createMatch(props));
    cfgs.forEach(c => {
      try {
        const nViewModel = c.update(viewModel, context);
        viewModel = nViewModel || viewModel;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    });
    return viewModel;
  };
}
export default {
  create
};